import ChartWrapper from './chartWrapper.js';
export default ChartWrapper;
